var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { useForm } from "react-hook-form";
import Modal from "../../UI/Modal/Modal";
import NoteForm from "./NoteForm";
import ModalHeader from "../../UI/Modal/ModalHeader";
import { CancelButton, SaveButton, } from "../../UI/StandardButtons/StandardButtons";
import useService from "../../Hooks/useService";
import NoteService from "../../../Services/Note.service";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
const NoteModalContent = (props) => {
    const { setValue, register, control, errors, unregister, handleSubmit, getValues, } = useForm({
        defaultValues: {
            text: (props.note && props.note.text) || "",
            noteTypes: (props.note && props.note.noteTypes) || [],
        },
    });
    const { createFromMessage, note, studentAffiliationId, sourceId } = props;
    const [saveNoteState, saveNote] = useService(React.useMemo(() => (state) => {
        if (createFromMessage) {
            return NoteService.createNoteFromMessage(studentAffiliationId, state.noteTypes.map(({ id }) => ({ id })), state.text, sourceId);
        }
        if (note) {
            return NoteService.updateNoteWithText({
                noteId: note.id,
                noteTypes: state.noteTypes.map(({ id }) => ({ id })),
                text: state.text,
            });
        }
        return NoteService.createNoteWithText(studentAffiliationId, state.noteTypes.map(({ id }) => ({ id })), state.text);
    }, [note, studentAffiliationId, createFromMessage, sourceId]));
    const submit = (state) => {
        saveNote(state)
            .then(props.onSave)
            .then(() => props.closeModal());
    };
    return (_jsxs(_Fragment, { children: [_jsx(ModalHeader, { title: props.note ? "Edit Note" : "New Note", closeModal: props.closeModal }), _jsxs("form", { onSubmit: handleSubmit(submit), children: [_jsxs("div", { className: "modal-body", children: [_jsx(NoteForm, { register: register, control: control, setValue: setValue, unregister: unregister, errors: errors, getValues: getValues }), saveNoteState.hasError && (_jsx(AlertError, { message: "There was an error saving the note", detail: saveNoteState.errorMessage }))] }), _jsxs("div", { className: "modal-footer", children: [_jsx(SaveButton, { type: "submit", isLoading: saveNoteState.isLoading }), _jsx(CancelButton, { onClick: props.closeModal, disabled: saveNoteState.isLoading })] })] })] }));
};
const NoteModal = (_a) => {
    var { note, onSave, studentAffiliationId, 
    // @ts-expect-error - TS2339 - Property 'createFromMessage' does not exist on type 'Props & Diff<ModalProps, { children: Node; }>'.
    createFromMessage = false, 
    // @ts-expect-error - TS2339 - Property 'sourceId' does not exist on type 'Props & Diff<ModalProps, { children: Node; }>'.
    sourceId } = _a, modalProps = __rest(_a, ["note", "onSave", "studentAffiliationId", "createFromMessage", "sourceId"]);
    return (_jsx(Modal, Object.assign({}, modalProps, { backdrop: "static", children: modalProps.isOpen && (_jsx(NoteModalContent
        // @ts-expect-error - TS2322 - Type '((arg1: Note) => any) | undefined' is not assignable to type '((arg1: Note) => any) & ((arg1: Note) => any)'.
        , { 
            // @ts-expect-error - TS2322 - Type '((arg1: Note) => any) | undefined' is not assignable to type '((arg1: Note) => any) & ((arg1: Note) => any)'.
            onSave: onSave, note: note, closeModal: modalProps.onModalClosed, studentAffiliationId: studentAffiliationId, createFromMessage: createFromMessage, sourceId: sourceId })) })));
};
export default NoteModal;
